"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AppointmentRescheduleRequestSchema () {
        return AppointmentRescheduleRequestSchema;
    },
    get AppointmentRescheduleResponseSchema () {
        return AppointmentRescheduleResponseSchema;
    }
});
const _zod = require("zod");
const _optionaltrimmedtext = require("./optional-trimmed-text");
const AppointmentRescheduleRequestSchema = _zod.z.object({
    scheduledAt: _zod.z.string().datetime({
        offset: true
    }),
    durationMinutes: _zod.z.number().int().min(5).max(240),
    providerId: _zod.z.string().uuid(),
    room: (0, _optionaltrimmedtext.optionalTrimmedText)(40),
    expectedUpdatedAt: _zod.z.string().datetime({
        offset: true
    })
}).strict();
const AppointmentRescheduleResponseSchema = _zod.z.object({
    id: _zod.z.string().uuid(),
    updatedAt: _zod.z.string().datetime({
        offset: true
    })
});
